<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu" class="sd-mnu" [ngClass]="{'collapsed':isCondensed}">


    <accordion [isAnimated]="true" class="accordion custom-accordion" [closeOthers]="true">

      <ng-container *ngFor="let item of menuItems;let ij = index">
        <accordion-group class="accordion-item" id="o_1" *ngIf="!item.label?.toLowerCase().includes('invoice')" [isDisabled]="!item.expand" [isOpen]="opened[ij]" (isOpenChange)="log($event,ij)">
        <div accordion-heading class="accordian-custom" *ngIf="item.expand">
          <a href="javascript:void(0);" style="display:flex; justify-content: center; align-items: center;">
          <div class="col-lg-12 mb-3 row">
            <div class="col-lg-1" style="display: flex;justify-content: center;align-items: center;" >
              <i class="bx {{item.icon}} font-size-20" *ngIf="item.icon"></i>
            </div>

            <div class="col-lg-9" [ngClass]="{'disappear':isCondensed && screenSize > 768}">{{ item.label | translate }}</div>
            <div class="col-lg-1"  [ngClass]="{'disappear':isCondensed && screenSize > 768}"><i class='bx bx-chevron-down font-size-18' [ngClass]="{'rot':opened[ij]}"></i></div>

          </div>
        </a>
        </div>



        <div accordion-heading class="accordian-custom" *ngIf="!item.expand">
          <a routerLink="{{item.link}}"  style="display:flex; justify-content: center; align-items: center;">
          <div class="col-lg-12 mb-3 row">
            <div class="col-lg-1" style="display: flex;justify-content: center;align-items: center;" >
              <i class="bx {{item.icon}} font-size-20" *ngIf="item.icon"></i>
            </div>
            <div class="col-lg-10" [ngClass]="{'disappear':isCondensed && screenSize > 768}">{{ item.label | translate }}</div>

          </div>
          </a>
        </div>



          <div class="text-muted col-lg-12 sub-itm  mb-3 row" *ngFor="let subitem of item.subItems">
            <div class="col-lg-2"></div>
            <a routerLink="{{subitem.link}}" class="col-lg-10">
            <div class="col-lg-12" [ngClass]="{'disappear':isCondensed && screenSize > 768}">{{ subitem.label | translate}}</div>
            </a>
          </div>
      </accordion-group>
      </ng-container>
    </accordion>






    <!-- Left Menu Start -->

  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
